import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import Switch from 'react-router/Switch';
import Route from 'react-router/Route';
import Link from './links/Link';
import Container from './blocks/Container';
import Logo from './icons/Logo';
import TeamIcon from './icons/TeamIcon';
import ProfileIcon from './stateful/ProfileIcon';
import SpaceIcon from './icons/SpaceIcon';
import DropDownButton from './stateful/DropDown/DropDownButton';
import LinkButton from './links/LinkButton';
import ActionButtonLink from './links/ActionButtonLink';
import CreateButton from './buttons/CreateButton';
import theme from './theme';
import logout from '../helpers/logout';
import withUser from '../helpers/withUser';
import Flex from './blocks/Flex';
import PageTitle from '../components/headings/PageTitle';

const Navigation = styled.div`
  background: ${theme.colors.white};
  justify-content: flex-end;
`;

const NavbarContainer = Container.extend`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: 80px;
  line-height: 80px;
  padding: 0 ${theme.unit}px;

  @media screen and (min-width: ${theme.mobile}px) {
    padding: 0 ${theme.unit * 2}px;
  }
`;

const Nav = styled.div`
  display: flex;
  flex: 1;

  ul {
    display: flex;
    flex: 1;
    flex-direction: row;

    ${({ right }) => right && `
      justify-content: flex-end;
    `}
  }

  li {
    align-items: center;
    color: ${theme.colors.gray4};
    display: flex;
    flex: auto 0 0;
    font-weight: 600;
    justify-content: center;
    padding: 0 ${theme.unit * 2}px;

    &:last-child {
      padding-right: 0;
    }
  }

  .active {
    color: ${theme.colors.active};
  }
`;

const LogoLink = Logo.withComponent(Link).extend`
  align-self: center;
  flex-basis: 40px;
  flex-grow: 0;
  flex-shrink: 0;
  height: 40px;
  line-height: 0;
  margin-right: 16px;
  width: 40px;
`;

const Navbar = ({ t, manager, user }) => (
  <Navigation>
    <NavbarContainer>
      <LogoLink to={manager ? '/spaces' : '/'} />
      {!manager && (
        <PageTitle>SpaceTranslate</PageTitle>
      )}
      <Nav>
        {manager ? (
          <ul>
            <li>
              <Link activeClassName="active" to="/spaces">Spaces</Link>
            </li>
            <li>
              <Link exact to="/explorer">API</Link>
            </li>
            {/* <li>
              <Link activeClassName="active" to="/support">Support</Link>
            </li> */}
          </ul>
        ) : (
          <ul>
            {/* <li>
              <Link exact to="/about">About</Link>
            </li>
            <li>
              <Link exact to="/pricing">Pricing</Link>
            </li> */}
          </ul>
        )}
      </Nav>
      <Nav right>
        {manager ? (
          <ul>
            <Switch>
              <Route path="/spaces/new" />
              <Route path="/spaces/:alias/presets/new" />
              <Route path="/settings/team/new" />
              <Route
                render={() => (
                  <li>
                    <DropDownButton
                      align="center"
                      showArrow
                      options={[{
                        type: 'info',
                        options: [{
                          value: (
                            <Flex horizontal valign="center">
                              <SpaceIcon small name="SC" />
                              <Flex vertical>
                                <div>{t('create_space')}</div>
                                <small>{t('create_space_desc')}</small>
                              </Flex>
                            </Flex>
                          ),
                          to: '/spaces/new',
                        }, {
                          value: (
                            <Flex horizontal valign="center">
                              <TeamIcon small name="T" />
                              <Flex vertical>
                                <div>{t('create_team')}</div>
                                <small>{t('create_team_desc')}</small>
                              </Flex>
                            </Flex>
                          ),
                          to: '/settings/team/new',
                        }],
                      }]}
                    >
                      <CreateButton small bold>Create</CreateButton>
                    </DropDownButton>
                  </li>
                )}
              />
            </Switch>
            <li>
              {user ? (
                <DropDownButton
                  showArrow
                  options={[{
                    type: 'info',
                    options: [{
                      value: (
                        <Flex horizontal valign="center">
                          <ProfileIcon small user={user} />
                          <Flex vertical>
                            <div>{user.name}</div>
                            <small>{user.email}</small>
                          </Flex>
                        </Flex>
                      ),
                      active: true,
                      // to: '/settings/profile',
                    // }, {
                    //   value: (
                    //     <Flex horizontal valign="center">
                    //       <TeamIcon small name="igdb" user={user} /> igdb
                    //     </Flex>
                    //   ),
                    //   to: '/settings/profile',
                    // }, {
                    //   value: (
                    //     <Flex horizontal valign="center">
                    //       <TeamIcon small name="spacetranslate" user={user} /> spacetranslate
                    //     </Flex>
                    //   ),
                    //   to: '/settings/profile',
                    }],
                  }, {
                    options: [{
                      value: 'Create a team',
                      to: '/settings/team/new',
                    }, {
                      value: 'Settings',
                      to: '/settings',
                    }, {
                      value: 'Logout',
                      to: '/',
                      onClick: () => logout(),
                    }],
                  }]}
                >
                  <LinkButton>
                    <ProfileIcon
                      user={user}
                    />
                  </LinkButton>
                </DropDownButton>
              ) : (
                <Link to="/login">
                  {t('login')}
                </Link>
              )}
            </li>
          </ul>
        ) : (
          <ul>
            {/* <li>
              <Link to="/documentation">API</Link>
            </li>
            <li>
              <Link to="/help">Help</Link>
            </li> */}
            <li>
              <Link to="/login">Log In</Link>
            </li>
            <li>
              <ActionButtonLink bold small to="/signup">Sign Up</ActionButtonLink>
            </li>
          </ul>
        )}
      </Nav>
    </NavbarContainer>
  </Navigation>
);


Navbar.propTypes = {
  t: PropTypes.func.isRequired,
  manager: PropTypes.bool,
  user: PropTypes.object,
};
Navbar.defaultProps = {
  manager: false,
  user: null,
};

export default compose(
  withUser,
  translate(),
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.js